import {Swiper,SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import React from "react";
import {useImages} from "./useImages";
import {Autoplay, EffectCoverflow} from "swiper/modules";

export function Reel() {
    const images = useImages("image","id");
    if (!images || images.length === 0) return null;
    return (
        <div className={"reel-wrapper"}>
            <Swiper
                key={images.length}
                modules = {[Autoplay,EffectCoverflow]}
                effect={"coverflow"}
                centeredSlides={true}

                autoplay = {{
                    delay:5000,

            }}
                loop={true}
                slidesPerView={3}
            >
                {images.map((image) =>(
                    <SwiperSlide key={image.id}>
                        <img src={image.img_URL} alt={image.alt} className={"imgPortrait"}/>
                    </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
}
